import { useEffect, useState } from 'react';

import { useGetAdminConversationCategoryList } from '@entities/AdminConversationCategory';
import { IForm } from '@entities/AdminConversationCategory/model/types';
import { Step } from '@features/AdminConversationCategoryUpsertModal/model/types';

export const useAdminConversationCategoryUpsertModal = (
    categoryId: number,
    formId: number | null
) => {
    const [step, setStep] = useState<Step>(Step.SELECT);

    const [formData, setFormData] = useState<IForm | null>(null);

    const { data } = useGetAdminConversationCategoryList();

    useEffect(() => {
        if (formId) {
            const currentForm = data
                ?.find((category) => category.id === categoryId)
                ?.items.find((form) => form.id === formId);

            setFormData(currentForm);
            setStep(currentForm.type as Step);
        }
    }, []);

    const onChangeStep = (value: Step) => {
        setStep(value);
    };

    return { step, onChangeStep, formData };
};
